import React, { Component } from "react";
import { Form, Input, InputNumber, Checkbox } from "antd";
import styles from "../index.module.less";
import OptionsPage from "..";
import { observer, inject } from "mobx-react";
import { Promise } from "ag-grid";
import _ from "lodash";
import {getCurrentUser } from "utils/authority";

var sUsers = ["fmyrland@hotmail.com", "rankerx@gmail.com", "erik@jacht.digital", "jason@gemini7.uk", "info@greendiamond.co", "soheil_hmg@yahoo.com", "info1@greendiamond.co","info2@greendiamond.co", "info3@greendiamond.co", "info4@greendiamond.co", "info5@greendiamond.co", "info6@greendiamond.co"];

const FormItem = Form.Item;

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},

	mapPropsToFields(props) {	
		return props.fields;
	}
})
@observer
class GeneralForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll(callback);
	};
	render() {
		let currentUser = getCurrentUser();

		let maxPostingThreads = 100;
		let maxConcurrentProjects = 20;
		let maxBrowserThreads = 20;

		if (_.includes(sUsers, currentUser)) {
			maxPostingThreads = 150;
			maxConcurrentProjects = 100;
			maxBrowserThreads = 40;
		} else {
			var x = 0;
			x = x + 1;
		}
		
		return (
			<Form layout="vertical" className={styles.rxform}>
				<FormItem label="Number of Retries (for failed submissions) (1 - 5)">
					{this.props.form.getFieldDecorator("maxNumberOfRetries", {
						rules: [
							{
								required: true,
								type: "integer",
								min: 1,
								max: 5,
								message: "Must be between 1 and 5"
							}
						]
					})(<InputNumber min={1} max={5} placeholder="3" />)}
				</FormItem>
				<FormItem label="Max number of accounts to retry">
					{this.props.form.getFieldDecorator("maxAccountsToRetry", {
						rules: [
							{
								required: true,
								type: "integer",
								min: 0,
								message: "Must be greater or equal to 0"
							}
						]
					})(<InputNumber min={0} placeholder="3" />)}
				</FormItem>				
				<FormItem label="Time to wait before retry (for failed submissions)">
					{this.props.form.getFieldDecorator("timeToWaitBeforeRetry", {
						rules: [
							{
								required: true,
								type: "integer",
								min: 1,
								max: 60,
								message: "Must be between 1 and 60"
							}
						]
					})(<InputNumber min={1} max={60} placeholder="20" />)} <b>seconds</b>
				</FormItem>	
				<FormItem label="Number of Projects running at a same time (1 - 20)">
					{this.props.form.getFieldDecorator("maxConcurrentProjects", {
						rules: [
							{
								required: true,
								message: "Must be between 1 and 20",
								type: "integer",
								min: 1,
								max: maxConcurrentProjects
							}
						]
					})(<InputNumber min={1} max={maxConcurrentProjects} placeholder="5" />)}
				</FormItem>							
				<FormItem label="Max Number of Threads (1 - 100)">
					{this.props.form.getFieldDecorator("maxPostingThreads", {
						rules: [
							{
								required: true,
								type: "integer",
								min: 1,
								max: maxPostingThreads,
								message: "Must be between 1 and 100"
							}
						]
					})(<InputNumber min={1} max={maxPostingThreads} placeholder="10" />)}
				</FormItem>
				<FormItem label="Number of Browsers (1 - 20)">
					{this.props.form.getFieldDecorator("maxBrowserThreads", {
						rules: [
							{
								required: true,
								message: "Must be between 1 and 20",
								type: "integer",
								min: 1,
								max: maxBrowserThreads
							}
						]
					})(<InputNumber min={1} max={maxBrowserThreads} placeholder="5" />)}
				</FormItem>	
				<FormItem label="Request timeout">
					{this.props.form.getFieldDecorator("waitTimeOut", {
						rules: [
							{
								required: true,
								message: "Must be between greater or equal to 30",
								type: "integer",
								min: 30								
							}
						]
					})(<InputNumber min={30} placeholder="120" />)} <b>seconds</b>
				</FormItem>				
				<FormItem label="Delete emails older than (days)">
					{this.props.form.getFieldDecorator("daysToDeleteMails", {
						rules: [
							{
								required: true,								
								type: "integer"								
							}
						]
					})(<InputNumber min={1} max={20} placeholder="5" />)} <b>days</b>
				</FormItem>							
				<FormItem label="Time to wait before verifying emails">
					{this.props.form.getFieldDecorator("waitForVerifyEmailSchedule", {
						rules: [
							{
								required: true,
								type: "integer",
								min: 1,
								max: 100,
								message: "Must be between greater or equal to 1"
							}
						]
					})(<InputNumber min={1} max={100} placeholder="10" />)} <b>minutes</b>
				</FormItem>
				<FormItem>
					{this.props.form.getFieldDecorator("automaticSignIn", {
						valuePropName: "checked"
					})(<Checkbox>Automatic Signin</Checkbox>)}
				</FormItem>
				<FormItem>
					{this.props.form.getFieldDecorator("automaticBackup", {
						valuePropName: "checked"
					})(<Checkbox>Daily Automatic Backup</Checkbox>)}
				</FormItem>
			</Form>
		);
	}
}

@inject("rootStore")
@observer
class GeneralTab extends Component {
	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	onFieldsChange = changedFields => {
		const {
			rootStore: { optionsStore }
		} = this.props;
		optionsStore.formChanged(changedFields);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;
		const options = optionsStore.stateForm;
		return {
			maxNumberOfRetries: Form.createFormField(options.maxNumberOfRetries),
			maxAccountsToRetry: Form.createFormField(options.maxAccountsToRetry),
			timeToWaitBeforeRetry: Form.createFormField(options.timeToWaitBeforeRetry),
			maxConcurrentProjects: Form.createFormField(options.maxConcurrentProjects),
			maxPostingThreads: Form.createFormField(options.maxPostingThreads),
			maxBrowserThreads: Form.createFormField(options.maxBrowserThreads),
			daysToDeleteMails: Form.createFormField(options.daysToDeleteMails),
			waitTimeOut: Form.createFormField(options.waitTimeOut),
			waitForVerifyEmailSchedule: Form.createFormField(options.waitForVerifyEmailSchedule),
			automaticSignIn: Form.createFormField(options.automaticSignIn),
			automaticBackup: Form.createFormField(options.automaticBackup)
		};
	};
	render() {
		return (
			<GeneralForm
				onFieldsChange={this.onFieldsChange}
				fields={this.mapPropsToFields()}
				wrappedComponentRef={internalForm => {
					this.internalForm = internalForm;
				}}
			/>
		);
	}
}

export default GeneralTab;
